import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class HttpClientService {
    constructor(private http: HttpClient) {

    }

    get(url): Promise<any> {
        return this.http.get(url)
            .toPromise();
    }
    post(url, data): Promise<any> {
        return this.http.post(url, data)
            .toPromise();
    }

    put(url, data): Promise<any> {
        return this.http.put(url, data)
            .toPromise();
    }

    delete(url, data): Promise<any> {
        return this.http.delete(url, data)
            .toPromise();
    }

    patch(url, data): Promise<any> {
        return this.http.patch(url, data)
            .toPromise();
    }

}


/*
Copyright 2017-2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/services/httpClient.service.ts